module.exports = __webpack_public_path__ + "static/media/creature-arm-right.142d5172.svg";